const messages = {
    buttons: {
        productBrochures: "Upptäck",
    },
    index: {
        title: "PRODUKTINFORMATION",
        description: "Ladda ner här de senaste broschyrerna och flygbladen för våra Bridgestone- och Firestone-däck.",
        categories: {
            productBrochures: {
                title: "Produktbroschyrer",
                description: "Broschyrer för Bridgestone- och Firestone-däckserier",
            },
            bDrive: {
              title: "Produktbilder",
              description: "Aktuella bilder finns för nedladdning i vår B-DRIVE-portal.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

